export default __webpack_public_path__ + "static/monetka-403ee94cf8f5e78573673df991acd3c1.png";